const V1_BASE_CUSTOMER_URL = 'v1/customers';

export const CONTACT_MESSAGE_URL = `${V1_BASE_CUSTOMER_URL}/:customerId/contact-message`;
